import Config from "../config/constants";
import axios, { AxiosResponse } from 'axios';

export const apiGetBranches = async (page: number, limit: number, accessToken: string, searchcond?:string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/branch/branchlist`;
    
    try {
        const response = await axios.get(url, {
            params: {
                page,
                limit,
                searchcond
            },
            headers: { access_token: accessToken }
        });
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};

export const apiRegisterBranch = async (params: any, accessToken: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/branch/register`;
    
    try {
        const response = await axios.post(url, params, {
            headers: { access_token: accessToken }
        });
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};

export const apiEditBranch = async (params: any, id:number, accessToken: string): Promise<AxiosResponse> => {
console.log("id=" + id);
    const url = `${Config.API_HOST}/api/admin/branch/${id}`;
    
    try {
        const response = await axios.patch(url, params, {
            headers: { access_token: accessToken }
        });
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};

export const apiFileUpload = async (params: any, accessToken: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/branch/fileupload`;
    
    try {
        const response = await axios.post(url, params, {headers: { access_token: accessToken }});
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};


/**
 * 주소 → 좌표. 네이버를 직접 부르지 않고 서버를 거친다.
 * 예전엔 이 화면이 naveropenapi 를 직접 호출하면서 NCP 시크릿을 소스에 갖고 있었고,
 * 그 값이 빌드 산출물(main.*.js)에 그대로 실려 브라우저에서 꺼낼 수 있었다.
 */
export const apiGeocodeBranchAddress = async (address: string, accessToken: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/branch/geocode`;

    const response = await axios.get(url, {
        params: { address },
        headers: { access_token: accessToken }
    });
    return response.data;
};

export const apiExcelBranch = async (accessToken: string, searchcond?: string) => {
    let url = `${Config.API_HOST}/api/admin/branch/export-excel`;
    
    // 검색 조건이 있으면 쿼리 파라미터로 추가
    if (searchcond) {
        url += `?searchcond=${encodeURIComponent(searchcond)}`;
    }
    
    try {
        const response = await axios.get(url, { 
            headers: { access_token: accessToken },
            responseType: 'blob' // 바이너리 데이터로 받기 위해 필요
        });
        return response.data;
    } catch (error) {
        console.error('Excel 다운로드 중 오류 발생:', error);
        throw error;
    }
};

/**
 * 지점 삭제. 서버는 **softDelete** 다 — 행이 사라지지 않고 `deletedAt` 이 채워진다.
 * 목록과 앱에서는 안 보이지만 DB 에는 남으므로 `deletedAt` 을 비우면 되살아난다.
 */
export const apiDeleteBranch = async (id: number, accessToken: string) => {
  const url = `${Config.API_HOST}/api/admin/branch/${id}`;
  try {
    const response = await axios.delete(url, {
      headers: { access_token: accessToken },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting 지점:', error);
    throw error;
  }
};
